var render = function (_h,_vm) {var _c=_vm._c;return _c('figure',{staticClass:"video",on:{"click":function($event){return _vm.props.click(_vm.props.video)}}},[_c('img',{attrs:{"width":"240","src":("https://img.youtube.com/vi/" + (_vm.props.video.url) + "/hqdefault.jpg")}}),_c('figcaption',[_vm._v(_vm._s(_vm.props.video.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }